import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_PutLogEventsCommand, se_PutLogEventsCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class PutLogEventsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Logs_20140328", "PutLogEvents", {})
    .n("CloudWatchLogsClient", "PutLogEventsCommand")
    .f(void 0, void 0)
    .ser(se_PutLogEventsCommand)
    .de(de_PutLogEventsCommand)
    .build() {
}
